/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Check_ResultInputs */

const vi_grower_area_camera_check_result = /** @type {(inputs: Grower_Area_Camera_Check_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết quả kiểm tra`)
};

/**

* @param {Grower_Area_Camera_Check_ResultInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_check_result = /** @type {((inputs?: Grower_Area_Camera_Check_ResultInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Check_ResultInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_check_result(inputs)
});